import React from 'react';

import { Divider } from '@hbf/dsl';

import { UserInformation } from '@ha/api/v2/types/UserInformation';

import { UserCard, UserCardStats } from 'ha/components/Redesign/UserCard';

type CardUserInformation = WithRequiredProperties<
  UserInformation,
  'advertiserBookingsCount' | 'listingsCount'
>;

function shouldShowStats(userInformation: CardUserInformation) {
  return (
    userInformation.advertiserBookingsCount > 0 &&
    userInformation.listingsCount > 0
  );
}

interface Props {
  linkTo: string;
  userInformation: CardUserInformation;
}

const UserCardDefault: React.FC<Props> = ({
  children,
  linkTo,
  userInformation,
}) => {
  const showStats = shouldShowStats(userInformation);

  return (
    <UserCard data-test-locator="UserCard - Default">
      {children}

      {showStats && <Divider />}

      {showStats && <UserCardStats linkTo={linkTo} />}
    </UserCard>
  );
};

export { UserCardDefault };
